module.exports = __webpack_public_path__ + "src/assets/games/9/38.jpg";